<template>
  <!-- TODO: consider refactoring ProProjectsList, ProProfileProjects, ProDashboardProjects into 1 component -->
  <div class="">
    <div v-if="proUserProjects.length">
      <div class="flex flex-wrap w-100 pa4">
        <!-- MASONRY VERSION -->
        <div v-masonry
             transition-duration="0.2s"
             item-selector=".item"
             column-width="340"
             fit-width="true"
             gutter="20">
          <div v-masonry-tile class="grid-item item" v-for="project in proUserProjects" :key="project.id">
            <!-- block item markup -->
            <pro-project-card
                :project="project"
                :show-buttons="false"
                :show-details-on-render="project.id === previewProjectId">>
            </pro-project-card>
          </div>
        </div>
      </div>
    </div>
    <div v-if="proUserProjectsFetched && !proUserProjects.length">
      <div class="bg-near-white tc pa6 br2 fw5 silver f4 ma4">
          <span class="f-headline">🐼</span><br>
          There are no posts for you to view.
      </div>
    </div>
  </div>
</template>

<script>

import proProfileService from '../../../../api/ProProfileService'
import proProjectDetailsModal from '../../project/components/ProProjectDetailsModal'
import proProjectCard from '../../project/components/ProProjectCard'

import { mapState, mapGetters } from 'vuex'

export default {
    name: 'ProProfileProjects',
    components: {
      proProjectDetailsModal, proProjectCard
    },
    props: {
        proUserId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapState(['currentUser', 'env', 'previewProjectId']),
        ...mapGetters(['userHasRolePro']),
    },
    data() {
        return {
            proUserProjectsFetched: false,
            proUserProjects: [],
            selectedProject: null,
            showModal: false
        };
    },
    methods: {
    },

    created() {
        proProfileService.getPublicProjectsForUser(this.proUserId).then(response => {
            this.proUserProjects = response.data;
            this.proUserProjectsFetched = true;
        }).catch(() => {
            this.proUserProjectsFetched = true;
        })
    }
}
</script>




// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/profile/components/ProProfileProjects.vue